export default __webpack_public_path__ + "static/media/gwn38.814952f6.webp";